import _defineProperty from "/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */
import { directiveContainer } from './directive-container.js';
import { directiveLeaf } from './directive-leaf.js';
import { directiveText } from './directive-text.js';
/**
 * @returns {Extension}
 */

export function directive() {
  return {
    text: _defineProperty({}, 58, directiveText),
    flow: _defineProperty({}, 58, [directiveContainer, directiveLeaf])
  };
}